import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
export function WeatherSmallRender(component, index) {
    return _jsx(Weather, { full: false });
}
export function WeatherFullRender(component, index) {
    return _jsx(Weather, { full: true });
}
export function Weather(props) {
    const context = Common.useSpaContext();
    const details = [];
    details.push(_jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "Vlhkost", en: "Humidity" }), children: [context?.state?.outside?.humidity, "%"] }, "1"));
    details.push(_jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "Tlak", en: "Pressure" }), children: [context?.state?.outside?.pressure, "hPa"] }, "2"));
    details.push(_jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "Slunce", en: "Sun power" }), children: [context?.state?.outside?.sunPower, "W/m2"] }, "3"));
    if (props.full) {
        details.push(_jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "V\u00EDtr", en: "Wind" }), children: [context?.state?.outside?.windSpeed, "m/s"] }, "4"));
        details.push(_jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "Pocitov\u00E1 teplota", en: "Wind chill" }), children: [context?.state?.outside?.windChill, "\u00B0C"] }, "5"));
        details.push(_jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "Rosn\u00FD bod", en: "Dew point" }), children: [context?.state?.outside?.dewPoint, "\u00B0C"] }, "6"));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("h1", { children: [context?.state?.outside?.temperature, "\u00B0C"] }), details] }));
}
